
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import ProcurementDetail from './ProcurementDetail';

const ProcurementDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  
  // If the ID is "new", redirect to the procurement form page
  if (id === 'new') {
    return <Navigate to="/procurements/new" replace />;
  }

  return (
    <Layout>
      <ProcurementDetail />
    </Layout>
  );
};

export default ProcurementDetailsPage;
